import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'

const UserActivationToggle = ({ user, onChange }) => {
  const dispatch = useDispatch()
  const onToggle = (action) => {
    rest.UserService.call_url_action(`${user.url}${action}`, 'POST', {}).then(
      (response) => {
        dispatch(
          showSuccessToast(
            `${user.email} status changed`,
            `${user.email} status changed to ${action}ed`
          )
        )
        onChange()
      },
      (errors) => {
        dispatch(
          showErrorToast(
            `error while changing status of ${user.email}`,
            errors.response.data
          )
        )
      }
    )
  }
  return (
    <ReactBootstrap.Dropdown.Item
      onClick={(e) => {
        e.stopPropagation()
        const method = user.is_active ? 'deactivate' : 'activate'
        onToggle(method)
      }}
    >
      {user.is_active ? 'Deactivate User Login' : 'Activate User Login'}
    </ReactBootstrap.Dropdown.Item>
  )
}

export default UserActivationToggle
